import { Input } from '@angular/core';
import { Subscriber } from 'rxjs/Subscriber';
import { ContractBase } from "../../contract.base";
import { ContractService } from '../../../../_services';
import { IIdName, IIdNameGeneric } from '../../../../_entities';

export class ContractIfrsBase extends ContractBase {

	constructor(contractService: ContractService) {
		super(contractService);

		this.ifrsInputModes = [
			{ id: 1, name: 'Alt 1 - Simplified input' },
			{ id: 2, name: 'Alt 2 - Specified Input and / or by "Rental Staircase"' }
		];

		this.baseRentKinds = [{ id: 1, name: 'Amount' }, { id: 2, name: 'Percentage' }];

		this.costKinds = ['Common charges', 'Marketing cost', 'Opex', 'Yearly Rent', 'Electrical', 'Waste handling']
			.map(x => { return { id: x, name: x } });

		this.indexTypes = [{ id: 1, name: 'Monthly index' }, { id: 2, name: 'Year average' }];

		this.yesNoItems = [{ id: false, name: 'No' }, { id: true, name: 'Yes' }];

		this.paymentPeriods = [
			{ id: 1, name: 'Month' },
			{ id: 5, name: 'Every Second Month' },
			{ id: 2, name: 'Quarter' },
			{ id: 3, name: 'Half year' },
			{ id: 4, name: 'Year' }
		];


	}

	@Input() report: any;

	indexTypes: IIdName[];

	ifrsInputModes: IIdName[];

	baseRentKinds: IIdName[];

	paymentPeriods: IIdName[];

	yesNoItems: any[];


	costKinds: any[];

	get contractIfrs() {
		if (!!this.contract)
			return this.contract.ifrs;
		return null;
	}


}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/shared/contract/ifrs/base/contract-ifrs.base.ts